module.exports = __webpack_public_path__ + "img/home_snake_1.3ce9ee8b.jpg";